module.exports = __webpack_public_path__ + "img/Interview Icon - charcoal.78cf73a6.svg";